import { FunctionComponent } from 'react'

import config from '@config'
import EmbeddedContent from '@components/EmbeddedContent'

const {
  socialembeds: { blueSkyEmbedStaticPageUrl },
} = config

interface BlueSkyComponentProps {
  url: string
}

const BlueSkyComponent: FunctionComponent<BlueSkyComponentProps> = ({
  url,
}) => <EmbeddedContent url={`${blueSkyEmbedStaticPageUrl}${url}`} />

export default BlueSkyComponent
